<template>
  <div>
    <div class="main-container">
      <div class="circle-desc-container" v-if="currentCircle && currentSelectedCircle && !loading">
        <div
          class="back-btn-container"
          @click="
            $router.push({
              name: 'DefaultCircle',
              params: {
                page: $route.params.page,
              },
            })
          "
        >
          <span class="back-btn"><font-awesome-icon size="1x" :icon="['far', 'arrow-left']" :style="{ color: getPrimaryColor() }"/></span>
          <div class="back-btn" :style="{ color: getPrimaryColor() }">back</div>
        </div>
        <div v-if="currentCircle.circle_attach.url && currentCircle.circle_attach.url" class="desimage">
          <img
            class="circle-image"
            v-if="currentCircle.circle_attach.url && currentCircle.circle_attach.resized_images && currentCircle.circle_attach.resized_images.dov1280x720"
            :src="currentCircle.circle_attach.resized_images.dov1280x720"
            alt="circle_image"
          />
        </div>
        <div class="no-img" v-else>
          <img src="../../assets/icons/no-image.svg" width="20px" height="18px" alt="defualtImage" />
        </div>
        <span class="circle-title">{{ currentCircle.condition_type }} {{ !currentCircle.condition_type.toLowerCase().includes("circle") ? " Circle" : "" }}</span>
        <span v-if="currentCircle.description" class="circle-content">{{ currentCircle.description }} </span>
        <span class="circle-content">{{ currentCircle.long_description ? currentCircle.long_description : "" }} </span>
        <span v-if="currentCircle.circle_type.length > 0" class="circle-subtitle"
          >Types of
          {{
            currentCircle.condition_type
              .replace("My", "")
              .replace("Circle", "")
              .replace("my", "")
              .replace("circle", "")
              .trim()
          }}
        </span>
        <div class="tags">
          <div :class="showMore === true ? 'noshow' : 'show'" v-if="!showMore" v-for="(type, index) in currentCircle.circle_type" :key="index">
            <span
              @click="() => (showMore = true)"
              v-if="index === 3 && !showMore"
              class="tag"
              :style="{ 'text-transform': 'lowercase', cursor: 'pointer', background: getPrimary50Color(), color: getPrimaryColor() }"
            >
              +{{ currentCircle.circle_type.length - index }} more
            </span>
            <span v-if="index < 3 && !showMore" class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">
              {{ type.display_name }}
            </span>
          </div>
          <div v-if="showMore" v-for="(type, index) in currentCircle.circle_type" :key="index">
            <span class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">{{ type.display_name }}</span>
          </div>
          <span @click="() => (showMore = false)" v-if="showMore" class="tag" :style="{ 'text-transform': 'lowercase', cursor: 'pointer', background: getPrimary50Color(), color: getPrimaryColor() }">
            show less
          </span>
        </div>
        <span v-if="dovemedStats.hasOwnProperty('physicians')" class="circle-subtitle">DoveMed ecosystem has</span>
        <div v-if="dovemedStats.hasOwnProperty('physicians')" class="eco-container">
          <div class="icon-containers">
            <img loading="lazy" class="icon" src="../../assets/userdoctor.svg" alt="icon" />
            <span class="icon-text">{{ formatNum(dovemedStats.physicians || 0) }} Physicians</span>
          </div>
          <div class="icon-containers">
            <img loading="lazy" class="icon" src="../../assets/hospitalwide.svg" alt="icon" />
            <span class="icon-text">{{ formatNum(dovemedStats.hospitals || 0) }} Hospitals</span>
          </div>
          <div class="icon-containers">
            <img loading="lazy" class="icon" src="../../assets/hospital.svg" alt="icon" />
            <span class="icon-text">{{ formatNum(dovemedStats.clinics || 0) }} Clinics</span>
          </div>
          <div class="icon-containers">
            <font-awesome-icon class="icon" :icon="['fal', 'hand-holding-heart']" />
            <span class="icon-text">{{ formatNum(dovemedStats.nfps || 0) }} Non-For-Profits</span>
          </div>
          <div class="icon-containers">
            <font-awesome-icon class="icon" :icon="['fal', 'user-nurse']" />
            <span class="icon-text">{{ formatNum(dovemedStats.ohcps || 0) }} Advanced Medical Professionals</span>
          </div>
        </div>
        <div class="counts-container">
          <div class="contents-counts">
            <div class="counts">
              {{ currentCircle.no_of_members }}
            </div>
            <div class="counts-heading">Members</div>
          </div>
          <div class="contents-counts">
            <div class="counts">
              {{ currentCircle.no_of_post }}
            </div>
            <div class="counts-heading">Posts</div>
          </div>
          <div class="contents-counts">
            <div class="counts">
              {{ currentCircle.comment_count }}
            </div>
            <div class="counts-heading">Replies</div>
          </div>
        </div>
        <div class="term-container">
          <input aria-label="check1" type="checkbox" class="checkbox" v-model="checkOne" />
          <span class="term">
            I agree to the <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`" target="_blank" class="term-link">Terms of Use</a>,
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-privacy-policy`" target="_blank" class="term-link">Privacy Policy</a>
            and
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-community-guidelines`" target="_blank" class="term-link">Community Guidelines.</a>
          </span>
        </div>
        <div class="term-container">
          <input aria-label="check2" type="checkbox" class="checkbox2" v-model="checkTwo" />
          <span class="term2">Send me information and updates about this condition (newsletter)</span>
        </div>
        <div class="btn-container">
          <a-button
            :class="!checkOne ? 'join-btn-disabled JoinBtndisabled' : currentSelectedCircle[0].enter ? 'enter-bttn enterButton' : 'join-btn JoinBtn'"
            v-bind:style="[!checkOne ? { background: getAlphaPrimaryColor50() } : { background: getPrimaryColor() }]"
            :disabled="!checkOne"
            @click="handleCircleJoin"
            :loading="isPageRouting"
            >{{ currentSelectedCircle[0].enter ? "ENTER" : "Join" }}</a-button
          >
        </div>
      </div>
      <div v-else class="d-flex justify-content-center mt-3" :style="{ 'min-height': '75vh' }">
        <div class="d-flex align-items-center">
          <div class="spinner-border spinner-class"></div>
        </div>
        <div
          class="d-flex align-items-center ml-2"
          :style="{
            'font-size': '34px',
          }"
        >
          Loading Circle Info...
        </div>
      </div>
      <SSOModal ref="modal" />
      <AccVerifyModal ref="accVerify" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./HeaderGeneric.vue"
import Footer from "./Footer.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import SSOLogin from "../login/login-register-component.vue"
import SSOModal from "../login/login-register-modal.vue"
import AccVerifyModal from "../Modals/AccountNotVerifiedWarning.vue"
import { faUserNurse } from "@fortawesome/pro-light-svg-icons"
import axios from "axios"

library.add(faUserNurse)
const AppRepository = RepositoryFactory.get("app")
const CircleRepository = RepositoryFactory.get("circle")
const UserRepository = RepositoryFactory.get("user")
const AboutCircleRepository = RepositoryFactory.get("aboutCircle")

export default {
  name: "CircleDescription",
  components: {
    Header,
    Footer,
    SSOLogin,
    SSOModal,
    AccVerifyModal,
  },
  data() {
    return {
      circleList: [],
      showMore: false,
      checkTwo: false,
      id: 0,
      checkOne: false,
      allCircles: null,
      myCircles: null,
      currentSelectedCircle: null,
      isPageRouting: false,
      userAdminRoles: ["hospital_administrator", "clinic_administrator", "doctor", "nfp_administrator", "hcp"],
      loading: false,
      dovemedStats: {},
    }
  },

  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },

  async mounted() {
    console.warn("CircleDescriptionPage.vue is mounted")
    await this.FindId()
    // if (!this.currentCircle || !this.authUser || !window.location.href.includes(encodeURIComponent(this.$route.params.circle))) {
    //   await this.FindId()
    // } else {
    //   await this.init()
    // }
    this.fetchDovemedStats()
  },

  watch: {
    isLoading: {
      handler() {
        if (this.isLoading === false) {
          this.FindId();
        }
      }
    }
  },

  methods: {
    formatNum(num) {
      return Intl.NumberFormat("en", { notation: "compact" }).format(num)
    },

    async fetchDovemedStats() {
      try {
        this.loading = true
        const res = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/utils/dovemed-stats/`)
        this.dovemedStats = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },

    async FindId() {
      if (this.$route.query.circle_id) {
        this.id = this.$route.query.circle_id
      } else {
        const res = await CircleRepository.alllist(this.$route.params.circle)
        this.circleList = res.data.data
        this.circleList.forEach(item => {
          if (this.$route.params.circle === item.key_name) {
            this.id = item.id
          }
        })
      }
      this.secondInit()
    },

    async secondInit() {
      await CircleRepository.all("", this.id)
        .then(async res => {
          this.$store.commit("Circle/setCurrentCircle", { data: res.data.data.all_circles[0] })
          this.myCircles = this.authUser ? (this.authUser.user.hasOwnProperty("verified_account") ? res.data.data.all_circles : res.data.data.my_circles) : []
          this.authUser && !this.authUser.user.hasOwnProperty("verified_account")
            ? (this.allCircles = await this.circleDiff(res.data.data.all_circles, res.data.data.my_circles))
            : (this.allCircles = await res.data.data.all_circles)
          this.currentSelectedCircle = this.allCircles.filter(circle => circle.id === this.currentCircle.id)
          if (this.currentSelectedCircle[0].enter) {
            this.handleCircleJoin()
          }
        })
        .catch(err => {})
    },

    handleCircleJoin() {
      this.isPageRouting = true
      if (!this.authUser) {
        // document.body.scrollTop = 0
        // setTimeout(() => {
        //   this.$refs.modal.open()
        // }, 1000)
        const currentPath = encodeURIComponent(window.location.href)
        window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${currentPath}`
      } else if (this.authUser && this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
        this.$refs.accVerify.showModal()
        this.isPageRouting = false
      } else {
        let isUserDoctor = []
        if (this.authUser.user.hasOwnProperty("role")) {
          isUserDoctor = this.authUser.user.multiRole.some(b => this.userAdminRoles.includes(b.role))
        }
        if (this.currentSelectedCircle[0].hasOwnProperty("enter")) {
          this.checkAndRoute(this.currentCircle)
        } else if (this.authUser.user.hasOwnProperty("role") && isUserDoctor) {
          AppRepository.getHasMultiRole(this.currentCircle.id)
            .then(res => {
              if (res.data.data.length === 1) {
                const payload = { role: res.data.data[0].role, circle_id: this.currentCircle.id }
                AppRepository.postHasMultiRole(payload).then(res => {
                  UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id).then(res => {
                    this.authUser.user.display_name = res.data.data.user_info.display_name || "D"
                    // this.authUser.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name.toLowerCase() : "D"
                    this.authUser.user.role = payload.role
                    this.$router.push({ path: `/${this.currentCircle.key_name}/signup`, query: { send_updates: this.checkTwo } })
                    this.isPageRouting = false
                  })
                })
              }
              if (res.data.data.length > 1) {
                this.$router.push({ path: `/${this.currentCircle.key_name}/signup`, query: { send_updates: this.checkTwo } })
                this.isPageRouting = false
              }
            })
            .catch(err => {})
        } else {
          this.checkForVerified()
        }
      }
    },
    ssoMultiLogin() {
      const payload = { dtoken: this.authUser.user.dovemed_csrf_token }
      AppRepository.ssoMultiRoleLogin(payload)
        .then(res => {
          if (res.data.data.length === 0) {
            this.checkForVerified()
          }
          if (res.data.data.length === 1) {
            this.ssoRegister(res.data.data[0])
          }
          if (res.data.data.length > 1) {
            this.$router.push({ path: `/${this.currentCircle.key_name}/signup`, query: { send_updates: this.checkTwo } })
          }
        })
        .catch(err => {})
    },

    ssoRegister(data) {
      AppRepository.enterCircleForMultiRole({ circle_id: this.currentCircle.id, dtoken: this.authUser.user.dovemed_csrf_token, role: data.role })
        .then(res => {
          const userData = { user: { ...res.data.data, multiRole: res.data.data.role } }
          this.$store.commit("User/setUser", { data: userData }, { root: true })
          this.$notification.success({ message: "Success", description: "Circle Registered Successfully" })
          this.checkAndRoute(this.currentCircle)
        })
        .catch(err => {})
    },

    checkForVerified() {
      if (this.authUser.user.hasOwnProperty("verified_account")) {
        if (this.authUser.user.verified_account === false) {
          this.$refs.accVerify.showModal()
        } else {
          this.$router.push({ path: `/${this.currentCircle.key_name}/signup`, query: { send_updates: this.checkTwo } }).catch(err => {})
        }
      } else {
        this.$router.push({ path: `/${this.currentCircle.key_name}/signup`, query: { send_updates: this.checkTwo } }).catch(err => {})
      }
    },

    async init() {
      await CircleRepository.all("", this.$route.query.circle_id)
        .then(async res => {
          this.myCircles = this.authUser ? (this.authUser.user.hasOwnProperty("verified_account") ? res.data.data.all_circles : res.data.data.my_circles) : []
          this.authUser && !this.authUser.user.hasOwnProperty("verified_account")
            ? (this.allCircles = await this.circleDiff(res.data.data.all_circles, res.data.data.my_circles))
            : (this.allCircles = await res.data.data.all_circles)
          this.currentSelectedCircle = this.allCircles.filter(circle => circle.id === this.$route.query.circle_id)
          if (this.currentSelectedCircle[0].enter) {
            this.handleCircleJoin()
          }
        })
        .catch(err => {})
    },

    /**
     * Filter circles based on the condition that it's present in mycicles or not
     *
     * @param {Array} allCircles
     */

    circleDiff(allCircles, myCircles) {
      if (this.authUser) {
        this.myCircles = myCircles || []
        const userCircles = myCircles || []
        // this.myCircles = this.authUser.user.circles || []
        // const userCircles = this.authUser.user.circles || []
        const isUserDoctor = this.authUser.user.multiRole.some(b => this.userAdminRoles.includes(b.role))
        allCircles.forEach(a => {
          const found = userCircles.some(b => b.id === a.id)
          if (found) {
            a["enter"] = true
          }
        })
        return allCircles
      }
    },

    checkAndRoute(circle) {
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            let selectedRole

            selectedRole = this.$store.state.User.user.user.multiRole.filter(r => r.circle_id === this.currentCircle.id)[0].role

            const payload = { role: selectedRole, circle_id: this.currentCircle.id }
            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, circle.id).then(res => {
                this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name : "D"
                this.authUser.user.role = selectedRole
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          }
          // if (res.data.data.length === 1) {
          //   const payload = {
          //     role: res.data.data[0].role,
          //     circle_id: this.currentCircle.id
          //   };

          //   AppRepository.postHasMultiRole(payload).then(res => {
          //     UserRepository.getSelfProfile(this.authUser.user, circle.id).then(
          //       res => {
          //         this.authUser.user.display_name = res.data.data.user_info.display_name.toLowerCase();
          //         this.authUser.user.role = payload.role;
          //         this.$router.push(
          //           `/${this.currentCircle.key_name}/home/activity`
          //         );
          //       }
          //     );
          //   });
          // }
          // if (res.data.data.length > 1) {
          //   this.$router.push(`/${this.currentCircle.key_name}/select-profile`);
          // }
          else {
            this.$router.push({ path: `/${this.currentCircle.key_name}/select-profile`, query: this.$route.query })
          }
        })
        .catch(err => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.noshow {
  display: none;
}
.show {
  display: flex;
}
.desimage {
  max-width: 790px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.no-img {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e2e8f0;
  max-width: 790px;
  width: 100%;
  height: 243px;
  border-radius: 8px 8px 0px 0px;

  @media only screen and (max-width: 900px) {
    height: 243px;
  }
}
.enterButton {
  background: #062b54;
  color: #ffffff;
}

.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  flex-direction: column;
  min-height: 100vh;
}
.checkbox {
  height: 18px;
  width: 18px;
  cursor: pointer;
}

.checkbox2 {
  height: 18px;
  width: 18px;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    width: 30px;
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.icon {
  height: 20px;
  width: 22.5px;
}
.icon-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #0f1734;
}
.icon-containers {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  height: 24px;
}

.back-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0px;
  gap: 4px;
  width: 59px;
  height: 30px;
  cursor: pointer;
}

.counts-heading {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.counts {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #0f1734;
}
.contents-counts {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  padding: 16px 0px;
  width: 100%;
  height: 70px;
  background: #f1f5f9;
  @media screen and (max-width: 600px) {
    flex-direction: column-reverse;
  }
}

.counts-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 13px;
  width: 100%;
  height: 70px;
}
.term {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.term2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  @media screen and (max-width: 600px) {
    margin-right: 64px;
  }
}

.term-link {
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #2a71d4 !important;
}

.JoinBtndisabled {
  background: #a1bde6 !important;
  color: #ffffff;
}

.JoinBtn {
  background: #2a71d4;
  color: #ffffff;
}

.btn-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 24px;
  width: 100%;
  height: 48px;
}

.term-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
}

.eco-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  @media screen and (max-width: 600px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  background: #e1eaf7;
  border-radius: 4px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #2a71d4;
  text-transform: capitalize;
  @media screen and (max-width: 600px) {
    justify-content: center;
    align-items: center;
  }
}

.tags {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
}

.circle-subtitle {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #0f1734;
}
.circle-content {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
}
.circle-title {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
}
.circle-image {
  height: 319px;
  border-radius: 8px 8px 0px 0px;
}
.back-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 24px;
  width: 793px;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
}
.circle-desc-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  max-width: 793px;
  width: 100%;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 100px;
  @media screen and (max-width: 660px) {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/CircleDescriptionPage.vue